<template>
  <div>
    <vue-element-loading
      is-full-screen
      :active="loading"
      spinner="bar-fade-scale"
      color="#152d51"
    />
    <div class="navbar nav-main w-100" style="background-color:#23409A;color:white">
      <h3 class="w-100 text-center my-3">ที่อยู่</h3>
    </div>
    <div class="w-100 session-with-nav " style="height: calc(100vh - 67px);overflow: auto;">
      <div class="px-5">
        <div v-if="step != 'address'" @click="backstep" class="text-blue back-style">
          <span style="font-size:20px;font-weight: 900;">&lt</span> back
        </div>
        <div class="mb-2 flex-all-center pt-5">
          <div>
            <v-img
              class="my-0 radius-circle"
              style="width:170px;height:auto"
              src="@/assets/logo_long.png"
            ></v-img>
          </div>
        </div>
        <!-- <div v-if="step == 'contact'">
          <div class="text-gray mb-3">สัญญาของคุณ สามารถรับบริการผ่าน Next Connect ได้ กรุณาเลือกสัญญาที่ต้องการเปลี่ยนแปลงข้อมูล</div>
          <List :data="contact" @select-contact="selectContact" />
        </div> -->
        <div v-if="step == 'address'">
          <div class="text-gray mb-3">กรุณาเลือกที่อยู่ที่ต้องการเปลี่ยนแปลงข้อมูล</div>
          <ListAddress :data="addressData" @select-address="setAddressList" />
        </div>
        <div v-if="step == 'address2'">
          <div class="text-gray mb-3">กดที่ที่อยู่เพื่อทำการแก้ไขข้อมูล</div>
          <div v-if="selectAddressList && selectAddressList.length">
            <div
              class="item-contact text-blue mb-4 d-flex justify-content-between"
              v-for="(item, index) in selectAddressList"
              :key="`contact-list-${index}`"
              @click="clickSelectAddress(item)"
            >
              <v-icon class="text-blue" style="display: flex;align-items: start;"
                >mdi-home-outline</v-icon
              >
              <div class="px-2">{{ formatAddress(item) }}</div>
              <v-icon class="text-blue" style="display: flex;align-items: start;"
                >mdi-square-edit-outline</v-icon
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import List from "@/components/selectAddress/List.vue";
import ListAddress from "@/components/selectAddress/ListAddress.vue";
import api from "@/api";
import config from "@/config";
import VueElementLoading from "vue-element-loading";
import moment from "moment";

export default {
  components: { List, ListAddress, VueElementLoading },
  data() {
    return {
      loading: true,
      step: "contact", // contact address address2
      list: ["address", "address2"],
      selectedContact: "",
      contactList: [],
      addressData: [],
      selectAddressList: [],
    };
  },
  computed: {
    checkOtp() {
      //   return true;
      return this.$store.state.checkOtp;
    },
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    userId() {
      return this.$store.state.profile.userId;
    },
    authData() {
      return this.$store.state.formatAuthorizeData;
    },
    contact() {
      if (this.contactList && this.contactList.length) {
        return this.contactList.map((x) => x.agreementNo);
      } else {
        return [];
      }
    },
    pageid() {
      return config.pageid;
    },
    topHead() {
      return "ยืนยันตัวตนสำเร็จ";
    },
    // userDataCom() {
    //   //   return { id: "U1d3ba1e92c5c07ffd32e41384d265218__105387828535129", first_name: "Oat", last_name: "", profile_pic: "https://sprofile.line-scdn.net/0hVU6kOlD8CXobEiB6dmR3BWtCChA4Y1BoP3JAGH5HAhojJUZ7ZHBDGygSXkslJxt4MXURGC4UB04XAX4cBUT1ThwiV00iJUwoM3dPlA", phoneno: "0968170261", cardnumber: "3101900169511", dob: "1983-03-12T17:00:00.000Z", status: "ผูกบัญชีแล้ว" };
    //   return this.$store.state.userData;
    // },
  },
  watch: {
    authData: {
      immediate: true,
      handler(authData) {
        if (authData) {
          this.setup();
        }
      },
    },
  },
  mounted() {
    this.selectContact();
  },
  methods: {
    stepTo(step) {
      this.step = step;
    },
    async setup() {
      // await this.fetchContact();
      this.loading = false;
    },
    backstep() {
      if (this.step == "address2") {
        this.step = "address";
      }
    },
    setAddressList(data, menu) {
      this.selectAddressList = data;
      this.$store.state.menu = menu;
      this.stepTo("address2");
    },
    clickSelectAddress(data) {
      this.$store.state.selectAddress = data;
      this.$router.push("/updateAddressNoRegisForm");
    },
    async selectContact(contact) {
      this.loading = true;
      this.addressData = await this.fetchAddress(contact);
      this.loading = false;
      if (this.addressData) {
        this.$store.state.selectContact = contact;
        this.stepTo("address");
      } else {
        this.$swal.fire({
          type: "error",
          text: "ไม่พบข้อมูลในระบบ",
        });
      }
    },
    // async fetchContact() {
    //   let body = {
    //     IDCard: this.userDataCom.cardnumber,
    //     BirthDay: moment(this.userDataCom.dob).format("DD/MM/YYYY"),
    //     pageid: config.pageid,
    //   };
    //   let res = await api.getContact(body);
    //   if (res && res.responsecode == 200) {
    //     this.contactList = res.data;
    //     if (this.contactList.length === 1) {
    //       await this.selectContact(this.contactList[0].agreementNo);
    //     }
    //   } else {
    //     this.$router.push("/regis");
    //   }
    // },
    // async fetchContact() {
    //   let body = {
    //     idCard: this.authData.idcard,
    //     birthDay: this.authData.dob,
    //     NextCard: this.authData.nextcard,
    //     pageid: config.pageid,
    //   };
    //   let res = await api.getContactNoRegised(body);
    //   if (res && res.responsecode == 200) {
    //     this.contactList = [res.data];
    //     if (this.contactList.length === 1) {
    //       await this.selectContact(this.contactList[0].agreementNo);
    //     }
    //   } else {
    //     this.$router.push("/regis");
    //   }
    // },
    async fetchAddress() {
      const body = {
        IDCard: this.authData.idcard,
        BirthDay: this.authData.dob,
        NextCard: this.authData.nextcard,
        pageid: config.pageid,
      };
      let res = await api.getaddressNoRegis(body);
      if (res && res.length) {
        return res;
      } else {
        console.log("error fetch user data");
        return false;
      }
    },
    formatAddress(data) {
      return `${data.roomNo ? `ห้อง${data.roomNo} ` : ""} ${
        data.floor ? `ชั้น${data.floor} ` : ""
      } ${data.building ? `ตึก ${data.building} ` : ""} ${
        data.addressNo ? `${data.addressNo} ` : ""
      } ${data.street ? `ถนน ${data.street} ` : ""} ${data.soi ? `ซอย ${data.soi} ` : ""} ${
        data.subDistrict ? `แขวง ${data.subDistrict} ` : ""
      } ${data.district ? `เขต ${data.district} ` : ""} ${data.city ? `${data.city} ` : ""} ${
        data.postCode ? data.postCode : ""
      }`;
    },
  },
};
</script>

<style lang="scss" scoped>
.back-style {
  position: absolute;
}
</style>
